import { render } from "./Carousel3D.vue?vue&type=template&id=bdac3f7e&scoped=true"
import script from "./Carousel3D.vue?vue&type=script&lang=js"
export * from "./Carousel3D.vue?vue&type=script&lang=js"

import "./Carousel3D.vue?vue&type=style&index=0&id=bdac3f7e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdac3f7e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
